import {
  channelListRenderHelper,
  channelRenderHelper, 
  languageRenderHelper,
} from '@op/pages/download/renderHelper';
import { DownloadConfigInfoType } from '@op/pages/download/types';
import { getMemeDetailsVideoList, getMemesTableList } from '@opm/services';

/**
 * Memes 列表下载配置
 * 按照 API 返回字段适配
 */
export const MarketingMemesDownload: DownloadConfigInfoType = {
  type: 'page',
  downloadFunc: params => {
    return getMemesTableList({
      data: { ...params, should_include_timeline: false },
    });
  },
  columns: ({ filter }) => {
    const isViewsTab = filter?.stat_type === 'views' || !filter?.stat_type;

    return [
      { key: 'title', header: 'Memes Name' },
      { key: 'title_zh', header: 'Memes Name (CN)' },
      {
        key: 'channels',
        header: 'Channel',
        renderHelper: [channelListRenderHelper],
      },
      { key: 'hot_time', header: 'First Seen' },
      { key: 'meme_type', header: 'Type' },
      { key: 'meme_type_zh', header: 'Type (CN)' },
      { key: 'meme_elements', header: 'Element' },
      { key: 'meme_elements_zh', header: 'Element (CN)' },
      {
        key: isViewsTab ? 'total_views' : 'total_likes',
        header: isViewsTab
          ? 'Top 500 New Video Views'
          : 'Top 500 New Video Likes',
      },
      { key: 'content', header: 'AI Meme Interpretation' },
      { key: 'content_zh', header: 'AI Meme Interpretation (CN)' },
      { key: 'raw_url', header: 'Demo Video Link' },
    ];
  },
};

export const MemeVideoDownload: DownloadConfigInfoType = {
  type: 'page',
  downloadFunc: params => {
    return getMemeDetailsVideoList({ data: params });
  },
  columns: () => {
    return [
      { key: 'video_title', header: 'Video Title(Origin)' },
      { key: 'video_title_en', header: 'Video Title(English)' },
      { key: 'video_title_zh', header: 'Video Title(Chinese)' },
      { key: 'author_name', header: 'Author' },
      {
        key: 'channel',
        header: 'Channel',
        renderHelper: [channelRenderHelper],
      },
      { key: 'video_url', header: 'URL' },
      { key: 'release_time', header: 'Release Time' },
      {
        key: 'language',
        header: 'Language',
        renderHelper: [languageRenderHelper],
      },
      { key: 'views', header: 'Views' },
      { key: 'shares', header: 'Shares' },
      { key: 'likes', header: 'Likes' },
      { key: 'comments', header: 'Comments' },
    ];
  },
};



export const MemeTrendDownload: DownloadConfigInfoType = { 
  columns: () => {
    return [
      { key: 'time', header: 'Date' },
      { key: 'views', header: 'TikTok Views' },
      { key: 'publications', header: 'Publications' }, 
    ];
  },
};
